import React, { useState, useCallback, useEffect, useMemo } from "react";
import {
  Card,
  TextField,
  PageActions,
  List,
  Page,
  Modal,
  Layout,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { ChannelsModal } from "./ChannelsModal";

const AddMenu = (props) => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [titleValue, setTitleValue] = useState("");
  const handleChangeTitle = (newValue) => {
    setTitleValue(newValue);
    setTitleError("");
  };

  const [titleError, setTitleError] = useState("");
  const [activeChannels, setActiveChannels] = useState(false);
  const handleChangeActiveChannels = useCallback(
    () => setActiveChannels(!activeChannels),
    [activeChannels]
  );
  const handleChangeActiveChannelsDone = () => {
    setActiveChannels(false);
    setChannelsToShow(selectedChannels);
  };
  const [channels, setChannels] = useState([]);
  const [channelsToShow, setChannelsToShow] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const handleSelectedChannels = (param) => {
    setSelectedChannels(param);
  };
  useEffect(() => {
    // axios
    //   .get(`/channels`)
    //   .then((result) => {
    //     setChannels(
    //       result.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //           id: item.id,
    //         };
    //       })
    //     );
    //   })
    //   .catch(function (error) {});
  }, []);
  return (
    <Page
      title="Add Menu"
      breadcrumbs={[
        {
          onAction: () => navigate(`/admin/navigation`),
        },
      ]}
    >
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <TextField
              label="Title"
              value={titleValue}
              onChange={handleChangeTitle}
              placeholder="e.g. Sidebar menu"
              error={titleError}
            />
          </Card>
        </Layout.Section>
        {/* <Layout.Section secondary>
          <Card
            title="Channels"
            sectioned
            actions={[
              { content: "Manage", onAction: () => setActiveChannels(true) },
            ]}
          >
            {channelsToShow && channelsToShow.length ? (
              <List type="bullet">
                {channelsToShow.map((element, index) => {
                  return (
                    <List.Item key={index}>
                      {findElementByID(channels, element) &&
                        findElementByID(channels, element).label &&
                        findElementByID(channels, element).label}
                    </List.Item>
                  );
                })}
              </List>
            ) : null}
          </Card>
        </Layout.Section> */}
      </Layout>
      <Modal
        open={activeChannels}
        onClose={handleChangeActiveChannels}
        title="Manage Channels"
        primaryAction={{
          content: "Done",
          onAction: handleChangeActiveChannelsDone,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleChangeActiveChannels,
          },
        ]}
      >
        <Modal.Section>
          <ChannelsModal
            channels={channels}
            handleSelectedChannels={handleSelectedChannels}
            selectedChannels={selectedChannels}
          />
        </Modal.Section>
      </Modal>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
    </Page>
  );

  function handleSave() {
    if (!titleValue) {
      setTitleError("This field is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("title", titleValue);
      form_data.append("is_active", 1);
      // selectedChannels && selectedChannels.length
      //   ? selectedChannels.forEach((selected, index) =>
      //       form_data.append(`channels[${index}]`, selected)
      //     )
      //   : form_data.append(`channels`, []);
      axios
        .post(`/navigation-lists`, form_data)
        .then((res) => {
          navigate(`/admin/navigation`);
        })
        .catch((err) => console.log(""));
    }
  }
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
};

export default AddMenu;
